import React from 'react';

interface FilterControlGroupProps {
	children: React.ReactNode;
}

export function FilterControlGroup(
	props: FilterControlGroupProps
): JSX.Element {
	return <div className="gpeb-filter-group">{props.children}</div>;
}
